import React, { useContext, useMemo, useState, useRef } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"
import IndexSlider from "../components/index-slider"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { randomBytes } from "crypto"
import { ViewportContext } from "../contexts/viewport-context"

const IndexPage = () => {
  useRedirectToLang("/")
  const dimensions = useContext(ViewportContext)
  const [sliderTheme, setSliderTheme] = useState(0)
  const [navTheme, setNavTheme] = useState("light")
  const currentNavTheme = useRef("light")

  const intervalFunction = index => {
    const newIndex = index + 1
    if ((newIndex < 3 && newIndex > 0) || newIndex === 4) {
      if (!sliderTheme) setSliderTheme(1)
      if (currentNavTheme.current === "light") {
        currentNavTheme.current = "dark"
        setNavTheme("dark")
      }
    } else {
      if (sliderTheme) setSliderTheme(0)
      if (currentNavTheme.current === "dark") {
        currentNavTheme.current = "light"
        setNavTheme("light")
      }
    }
  }

  const nextSlideClick = arr => {
    const index = arr.indexOf(true)
    if (index === 0 || index == 1 || index == 3) {
      if (!sliderTheme) setSliderTheme(1)
      if (currentNavTheme.current === "light") {
        currentNavTheme.current = "dark"
        setNavTheme("dark")
      }
    } else {
      if (sliderTheme) setSliderTheme(0)
      if (currentNavTheme.current === "dark") {
        currentNavTheme.current = "light"
        setNavTheme("light")
      }
    }
  }

  const prevSlideClick = arr => {
    const index = arr.indexOf(true)
    if (index === 0 || index == 3 || index == 2) {
      if (!sliderTheme) setSliderTheme(1)
      if (currentNavTheme.current === "light") {
        currentNavTheme.current = "dark"
        setNavTheme("dark")
      }
    } else {
      if (sliderTheme) setSliderTheme(0)
      if (currentNavTheme.current === "dark") {
        currentNavTheme.current = "light"
        setNavTheme("light")
      }
    }
  }

  return (
    <>
      {useMemo(
        () => (
          <Layout key={randomBytes(6).toString("hex")} width={dimensions[0]}>
            <SEO title="Home" />
            <IndexSlider
              key={randomBytes(6).toString("hex")}
              dimensions={dimensions}
              intervalFunc={intervalFunction}
              prevLabelFunc={prevSlideClick}
              nextLabelFunc={nextSlideClick}
            />
          </Layout>
        ),
        [dimensions]
      )}
      <Navigation path="/" width={dimensions[0]} navTheme={navTheme} />
    </>
  )
}

export default IndexPage
